import { useState } from "react";
import { FaX, FaLink, FaWhatsapp } from "react-icons/fa6";
import { FaXTwitter, FaFacebook, FaLinkedin } from "react-icons/fa6";
import { FaFacebookMessenger } from "react-icons/fa";
import defaultLogo from "../assets/default-logo.png";
import "./LinkPreviewModal.css";

const LinkPreviewModal = ({ isOpen, onClose, link, business, url }) => {
  const [showMore, setShowMore] = useState(false);
  const linkUrl = link?.url || "";
  const linkTitle = link?.title || "";
  const linkSubtitle = link?.subtitle || "";

  if (!isOpen || !link) return null;

  // Get the absolute URL that will be shared
  const getShareableUrl = () => {
    let absoluteUrl = linkUrl;
    if (
      !absoluteUrl.startsWith("http://") &&
      !absoluteUrl.startsWith("https://")
    ) {
      absoluteUrl = `https://${absoluteUrl}`;
    }
    return absoluteUrl;
  };

  const shareableUrl = getShareableUrl();

  // Use link title
  const displayTitle = linkTitle;

  // Build share text with title, description, and URL
  const buildShareText = () => {
    let text = displayTitle;
    if (linkSubtitle) {
      text += `\n\n${linkSubtitle}`;
    }
    text += `\n\n${shareableUrl}`;
    return text;
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareableUrl);
      // You could show a toast here
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleShare = (platform) => {
    const shareText = buildShareText();
    const encodedUrl = encodeURIComponent(shareableUrl);
    const encodedText = encodeURIComponent(shareText);
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodedText}`;
        break;
      case "twitter":
        const twitterText = linkSubtitle
          ? `${displayTitle}\n\n${linkSubtitle}\n\n${shareableUrl}`
          : `${displayTitle} ${shareableUrl}`;
        shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodeURIComponent(
          twitterText
        )}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      case "messenger":
        // Messenger sharing requires app setup, so we'll copy the link instead
        handleCopyLink();
        return;
      default:
        return;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleRegister = () => {
    window.open("https://mennu.mx", "_blank", "noopener,noreferrer");
  };

  const handleDiscover = () => {
    window.open("https://mennu.mx", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="link-preview-modal-overlay" onClick={onClose}>
      <div className="link-preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="link-preview-modal-header">
          <h2 className="link-preview-modal-title">Compartir enlace</h2>
          <button
            className="link-preview-modal-close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            <FaX />
          </button>
        </div>

        <div className="link-preview-preview-card">
          <div className="link-preview-card-content">
            <div className="link-preview-title">{displayTitle}</div>
            <div className="link-preview-url-container">
              <span className="link-preview-url">{shareableUrl}</span>
              <FaLink className="link-preview-url-icon" />
            </div>
            {showMore && linkSubtitle && (
              <div className="link-preview-description">{linkSubtitle}</div>
            )}
            {linkSubtitle && (
              <button
                className="link-preview-more-btn"
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? "Menos" : "Más"}
              </button>
            )}
          </div>
        </div>

        <div className="link-preview-modal-options">
          <div className="share-option" onClick={handleCopyLink}>
            <div className="share-option-icon share-option-icon--copy">
              <FaLink />
            </div>
            <span className="share-option-label">Copiar enlace</span>
          </div>

          <div className="share-option" onClick={() => handleShare("twitter")}>
            <div className="share-option-icon share-option-icon--twitter">
              <FaXTwitter />
            </div>
            <span className="share-option-label">X</span>
          </div>

          <div className="share-option" onClick={() => handleShare("facebook")}>
            <div className="share-option-icon share-option-icon--facebook">
              <FaFacebook />
            </div>
            <span className="share-option-label">Facebook</span>
          </div>

          <div className="share-option" onClick={() => handleShare("whatsapp")}>
            <div className="share-option-icon share-option-icon--whatsapp">
              <FaWhatsapp />
            </div>
            <span className="share-option-label">WhatsApp</span>
          </div>

          <div className="share-option" onClick={() => handleShare("linkedin")}>
            <div className="share-option-icon share-option-icon--linkedin">
              <FaLinkedin />
            </div>
            <span className="share-option-label">LinkedIn</span>
          </div>

          <div
            className="share-option"
            onClick={() => handleShare("messenger")}
          >
            <div className="share-option-icon share-option-icon--messenger">
              <FaFacebookMessenger />
            </div>
            <span className="share-option-label">Messenger</span>
          </div>
        </div>

        <div className="link-preview-modal-cta">
          <div className="link-preview-modal-cta-header">
            {business?.logo && (
              <div className="link-preview-modal-cta-logo-wrapper">
                <img
                  src={business.logo}
                  alt={business?.name || "Negocio"}
                  className="link-preview-modal-cta-logo"
                />
              </div>
            )}
            <h3 className="link-preview-modal-cta-title">
              Únete a {business?.name || business?.urlSlug || "mennu"} en
              Mennu.mx
            </h3>
          </div>
          <p className="link-preview-modal-cta-description">
            Obtén tu propio Mennu.mx gratis. El único enlace en bio en el que
            confían más de 70 millones de personas.
          </p>
          <div className="link-preview-modal-cta-buttons">
            <button
              className="link-preview-modal-btn link-preview-modal-btn--primary"
              onClick={handleRegister}
            >
              Regístrate gratis
            </button>
            <button
              className="link-preview-modal-btn link-preview-modal-btn--secondary"
              onClick={handleDiscover}
            >
              Descubre más
            </button>
          </div>
        </div>

        <div className="link-preview-modal-footer">
          <div className="link-preview-modal-footer-content">
            <span className="link-preview-modal-footer-text">Hecho con</span>
            <img
              src={defaultLogo}
              alt="Mennu.mx"
              className="link-preview-modal-footer-logo"
            />
            <span className="link-preview-modal-footer-text">Mennu.mx</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkPreviewModal;
